<template>
  <div class="header">
    <div class="wp-header">
      <a
        href="javascript:;"
        class="vip-logo"
        title="迅雷"
        @click="$router.push('/vip-rights')"
      ></a>
      <ul class="header-nav">
        <li v-for="(item, i) in tabs" :key="i">
          <a
            href="javascript:;"
            :class="{ cur: checkPath(item.name) }"
            @click="jump(item, i)"
          >
            {{ item.title }}
          </a>
        </li>
        <li @click="$router.push('/')">
          <button class="header-vipRights_button">平台首页</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        { title: '特权首页', path: '/vip-rights', name: 'vip-rights' },
        {
          title: '特权介绍',
          path: '/vip-rights/intro/counpon',
          name: 'vip-rights-intro'
        },
        {
          title: '成长体系',
          path: '/vip-rights/growth-system',
          name: 'vip-rights-growth-system'
        }
      ]
    }
  },
  computed: {
    curName() {
      return this.$store.state.route.name
    }
  },
  methods: {
    checkPath(name) {
      if (name === 'vip-rights-intro') {
        return this.curName.includes(name)
      }
      return this.curName === name
    },
    jump({ path }, index) {
      this.$router.push(path)
      this.tabs.forEach((e) => (e.cur = false))
      this.tabs[index].cur = true
    }
  }
}
</script>
